import {
  SET_STAGE,
  SET_TICKET,
  UPDATE_STAGE,
  UPDATE_TICKET,
  DELETE_STAGE,
  DELETE_TICKET,
} from "../actions/actions";

const initialState = [
  {
    id: "",
    name: "",
    items: [
      {
        id: "",
        priority: 0,
        title: "",
        contact: "",
        closingDate: "",
        chat: 0,
        attachment: 0,
        assignees: [],
      },
    ],
  },
];
const pipelineReducer = (state = initialState, action) => {
  let fieldIndex = state?.findIndex((o) => o.label === action?.payload?.label);

  switch (action.type) {
    case SET_STAGE:
      return [...state, action?.payload];

    case UPDATE_STAGE:
      if (fieldIndex > -1) {
        state[fieldIndex] = action?.payload;
      }
      return state;
    case DELETE_STAGE:
      if (fieldIndex > -1) {
        state.splice(fieldIndex, 1);
      }
      return [...state];
    case SET_TICKET:
      return [...state, action?.payload];

    case UPDATE_TICKET:
      if (fieldIndex > -1) {
        state[fieldIndex] = action?.payload;
      }
      return state;
    case DELETE_TICKET:
      if (fieldIndex > -1) {
        state.splice(fieldIndex, 1);
      }
      return [...state];
    default:
      return state;
  }
};

export default pipelineReducer;
